<template>
  <editor :name="_name"
          v-model="value"
          class="form-control"
          :init="options"/>
</template>

<script>
  import mixin from './mixin';
  import Editor from '@tinymce/tinymce-vue';
  import {apiHost, parseResponse, parseError} from 'src/utils';
  import {get} from 'lodash';

  export default {
    name: 'f-html',
    mixins: [mixin],
    components: {
      Editor,
    },
    computed: {
      options() {
        return Object.assign({
          readonly: this._readonly,
          height: 500,
          toolbar: this._readonly
            ? false
            : 'formatselect | bold italic strikethrough forecolor backcolor | link | ' +
            'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | ' +
            'removeformat',
          menubar: !this._readonly,
          statusbar: !this._readonly,
          plugins: [
            'code preview fullpage searchreplace autolink directionality visualblocks',
            'visualchars link codesample table charmap hr pagebreak nonbreaking',
            'anchor toc insertdatetime advlist lists textcolor wordcount contextmenu',
            'colorpicker textpattern media paste image',
          ],
          removed_menuitems: 'newdocument',
          images_upload_handler: (blobInfo, yes, no) => {
            let blob = blobInfo.blob();
            this.$http
              .post('', {
                endpoint: 'uploadPNG',
                type: this.spec.uploadType || "image",
                sub_type: this.spec.uploadSubType || "default",
                tags: [],
                privacy: 1,
                details: {
                  filename: blob.name,
                  mime: blob.type,
                  size: blob.size,
                },
                image: blobInfo.base64(),
              })
              .then(parseResponse)
              .then(response => {
                let mid = get(response, 'body.data.mediaprofile_id');
                if (!mid) {
                  no('Empty response from server');
                } else {
                  yes(apiHost() + 'media/original/' + mid);
                }
              }, err => {
                no(parseError(err));
              });
          },
        }, this.spec.options);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-html.vue?6262048b